import React from 'react'
import { useSecretValue } from './SecretValueInput.hooks'
import VisibilityAdornment from '@/components/ui/VisibilityAdornment'
import FormikInput from '@/components/formik/FormikInput'

export type ValueInputProps = {
  name: string
  label: string
  secretId?: number
  projectId: number
}

export const SecretValueInput = ({ name, label, projectId, secretId }: ValueInputProps) => {
  const { isVisible, onShow, onHide } = useSecretValue('value', projectId, secretId)

  return (
    <FormikInput
      name={name}
      label={label}
      type={isVisible ? 'text' : 'password'}
      endAdornment={<VisibilityAdornment onShow={onShow} onHide={onHide} />}
      autoComplete="off"
    />
  )
}
